import { render, staticRenderFns } from "./ChildJobs.yaml?vue&type=template&id=476b5a19&component"
import script from "./ChildJobs.yaml?vue&type=script&lang=ts&component"
export * from "./ChildJobs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports